import React, { useState } from 'react';
import TopLinksBar from './top_links_bar';
import {
  Badge,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Link,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import logoMtGovBrIcon from '../../assets/icons/logo-mtgovbr-icon.svg';
import NotificationsIcon from '@mui/icons-material/Notifications';
import {
  CustomSecondaryAppBar,
  LogoContainer,
  RightContainer,
} from './top_nav_bar.styles';
import { InitialsAvatar } from 'components/shared';
import { useAuth } from 'contexts/auth/auth_context';
import { toTitleCase } from 'common/utils/string.util';
import { getURLMTLogout } from 'services/auth/config';
import { ROUTES } from 'routes/constants';
import { useNavigate } from 'react-router-dom';

// Exported handlers for unit testing
export const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, setAnchorEl: any) => {
  setAnchorEl(event.currentTarget);
};

export const handleMenuClose = (setAnchorEl: any) => {
  setAnchorEl(null);
};

export const handleLogoutClick = (setAnchorEl: any, setIsDialogOpen: any) => {
  setAnchorEl(null);
  setIsDialogOpen(true);
};

export const handleCloseDialog = (setIsDialogOpen: any) => {
  setIsDialogOpen(false);
};

export const handleLogoutConfirm = (logout: () => void, getLogoutUrl: () => string = getURLMTLogout) => {
  logout();
  // redirect to external logout URL
  window.location.href = getLogoutUrl();
};

const textStyle = {
  fontFamily: 'Roboto',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  letterSpacing: '0.17px',
  textAlign: 'left',
  color: '#00000099',
};

const TopNavBar: React.FC = () => {
  const { user, logout } = useAuth();
  const userRegistration = '123456789';
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const open = Boolean(anchorEl);

  const handleMenuOpenLocal = (event: React.MouseEvent<HTMLElement>) => handleMenuOpen(event, setAnchorEl);

  const handleMenuCloseLocal = () => handleMenuClose(setAnchorEl);

  const handleLogoutClickLocal = () => handleLogoutClick(setAnchorEl, setIsDialogOpen);

  const handleCloseDialogLocal = () => handleCloseDialog(setIsDialogOpen);

  const handleLogoutConfirmLocal = () => handleLogoutConfirm(logout);

  return (
    <>
      <TopLinksBar />
      <CustomSecondaryAppBar>
        <Link href='/painel' underline='none'>
          <LogoContainer>
            <img src={logoMtGovBrIcon} alt='Logo' style={{ height: '40px' }} />
          </LogoContainer>
        </Link>
        <RightContainer>
          <Badge badgeContent={0} color='primary'>
            <NotificationsIcon color='action' fontSize='large' />
          </Badge>
          <InitialsAvatar
            name={toTitleCase(String(user?.name))}
            onClick={handleMenuOpenLocal}
            style={{ cursor: 'pointer' }}
            variant='circular'
          />

          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuCloseLocal}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            PaperProps={{
              sx: {
                width: 'auto',
              },
            }}
          >
            {user && (
              <MenuItem
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  flexWrap: 'nowrap',
                  alignItems: 'flex-start',
                }}
                onClick={() => navigate(ROUTES.USER_EDIT.replace(':uuid', user?.uuid))}
              >
                <Typography
                  sx={{
                    fontFamily: 'Roboto',
                    fontSize: '16px',
                    fontWeight: 400,
                    lineHeight: '24px',
                    letterSpacing: '0.15px',
                    textAlign: 'left',
                    color: '#000000DE',
                  }}
                >
                  {toTitleCase(String(user?.name))}
                </Typography>
                <Typography sx={textStyle}>
                  Matrícula: {userRegistration}
                </Typography>
                <Typography sx={textStyle}>
                  Perfil: {toTitleCase(String(user?.permission?.profile?.name))}
                </Typography>
                <Typography sx={textStyle}>
                  Permissão: {toTitleCase(String(user?.permission?.name))}
                </Typography>
              </MenuItem>
            )}
            <Divider />
            <MenuItem onClick={handleLogoutClickLocal} sx={{ padding: '0px' }}>
              <Button variant='text'>
                <Typography
                  sx={{
                    fontFamily: 'Roboto',
                    fontSize: '13px',
                    fontWeight: 500,
                    lineHeight: '22px',
                    letterSpacing: '0.46px',
                    textAlign: 'left',
                    color: '#000000DE',
                  }}
                >
                  Sair
                </Typography>
              </Button>
            </MenuItem>
          </Menu>
        </RightContainer>
      </CustomSecondaryAppBar>

      <Dialog
        open={isDialogOpen}
        fullWidth
        maxWidth='md'
        sx={{ width: '100%' }}
        onClose={handleCloseDialogLocal}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            textAlign: 'left',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Roboto',
              fontSize: '24px',
              fontWeight: 500,
              lineHeight: '38.4px',
              letterSpacing: '0.15px',
              textAlign: 'left',
              color: '#000000DE',
              marginTop: '20px',
            }}
          >
            Sair do sistema
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            sx={{
              fontFamily: 'Roboto',
              fontSize: '18px',
              fontWeight: 400,
              lineHeight: '27px',
              letterSpacing: '0.15px',
              textAlign: 'left',
              color: '#000000DE',
            }}
          >
            Deseja sair e realizar o logout?
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: 'left',
            marginLeft: '10px',
            marginBottom: '10px',
          }}
        >
          <Button onClick={handleCloseDialogLocal}>
            <Typography
              sx={{
                fontFamily: 'Roboto',
                fontSize: '14px',
                fontWeight: 500,
                lineHeight: '24px',
                letterSpacing: '0.4px',
                textAlign: 'left',
                color: '#0048B6',
              }}
            >
              VOLTAR
            </Typography>
          </Button>

          <Button onClick={handleLogoutConfirmLocal}>
            <Typography
              sx={{
                fontFamily: 'Roboto',
                fontSize: '14px',
                fontWeight: 500,
                lineHeight: '24px',
                letterSpacing: '0.4px',
                color: '#D32F2F',
              }}
            >
              sair
            </Typography>
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TopNavBar;
